import React from "react";

import Equalizer from "@mui/icons-material/Equalizer";
import EventNote from "@mui/icons-material/EventNote";
import Security from "@mui/icons-material/Security";
import People from "@mui/icons-material/People";
import CurrencyPound from "@mui/icons-material/CurrencyPound";
import AccountBalanceWallet from "@mui/icons-material/AccountBalanceWallet";
import Settings from "@mui/icons-material/Settings";
import Info from "@mui/icons-material/Info";
import ReceiptLong from "@mui/icons-material/ReceiptLong";

const NavbarConfig = [
  {
    title: "Report",
    route: "/reports",
    icon: <Equalizer />,
  },
  {
    title: "Teams",
    route: "/teams",
    icon: <Security />,
  },
  {
    title: "Members",
    route: "/members",
    icon: <People />,
  },
  // {
  //   title: "Events",
  //   route: "/events",
  //   icon: <Event />
  // },
  {
    title: "Event types",
    route: "/event-types",
    icon: <EventNote />,
  },
  {
    title: "Fee levels",
    route: "/fee-levels",
    icon: <CurrencyPound />,
  },
  {
    title: "Event fees",
    route: "/event-fees",
    icon: <AccountBalanceWallet />,
  },
  {
    title: "Adjustment reasons",
    route: "/adjustment-reasons",
    icon: <ReceiptLong />,
  },
  {
    title: "Club settings",
    route: "/club-settings",
    icon: <Settings />,
  },
  {
    title: "Player information",
    route: "/player-information",
    icon: <Info />,
  },
];

export default NavbarConfig;
